import ShopStatusPage from "../components/ShopStatusPage";

const Error500Page = () => <ShopStatusPage message="Something went wrong." />;

export default Error500Page;
